import type { JobStatus } from "../../../api/generated/model";

export interface StatusLook {
  label: string;
  color: string;
}

const STATUS: Record<JobStatus, StatusLook> = {
  queued: { label: "Queued", color: "gray" },
  submitting: { label: "Sending to the model", color: "blue" },
  running: { label: "Running", color: "blue" },
  finalizing: { label: "Finishing", color: "blue" },
  succeeded: { label: "Done", color: "teal" },
  failed: { label: "Failed", color: "red" },
  expired: { label: "Timed out", color: "red" },
  canceled: { label: "Canceled", color: "gray" },
};

/**
 * How a status looks, on the job page and in the list. The table covers every status this build
 * knows; a status the API added later shows as itself, never as a crash.
 */
export function statusLook(status: string): StatusLook {
  const known: Partial<Record<string, StatusLook>> = STATUS;
  return known[status] ?? { label: status, color: "gray" };
}
